import ChipTaskCheckType, {
    type StatusChipProps,
} from '@/components/chip/ChipTaskCheckTypeStatus';
import { TaskCheckTypeEnum } from '@/types/enums/task-check-type.enum';

type TaskCheckTypeData = {
    label: string;
    color:
        | 'info'
        | 'warning'
        | 'success'
        | 'error'
        | 'default'
        | 'primary'
        | 'secondary';
    colorHex: string;
};

export const getTaskCheckTypeData = (
    props: StatusChipProps
): TaskCheckTypeData => {
    return ChipTaskCheckType({
        ...props,
        showChip: false,
    }) as TaskCheckTypeData;
};

export const getTaskCheckTypeOptionsFilter = (isFilter?: boolean) => {
    const enumValues = TaskCheckTypeEnum;

    const options: any[] = [];

    (
        Object.entries(enumValues) as [
            keyof typeof enumValues,
            (typeof enumValues)[keyof typeof enumValues],
        ][]
    ).forEach(([key, value]) => {
        const data = getTaskCheckTypeData({
            status: value as TaskCheckTypeEnum,
        });

        options.push({
            id: value,
            value: !isFilter ? value : String(key).toUpperCase(),
            title: data.label,
            label: data.label,
            color: data.colorHex,
        });
    });

    return options;
};
